import { createSelector } from 'reselect';

const executiveSummarySelector = state => state.ExecutiveSummary;

export const errorsSelector = createSelector(
  executiveSummarySelector,
  ({ errors }) => errors,
);

export const executiveSummaryMessageSelector = createSelector(
  executiveSummarySelector,
  ({ executiveSummaryMessage }) => executiveSummaryMessage,
);

export const isSavingExecutiveSummarySelector = createSelector(
  executiveSummarySelector,
  ({ isSavingExecutiveSummary }) => isSavingExecutiveSummary,
);

export const isDeletingExecutiveSummarySelector = createSelector(
  executiveSummarySelector,
  ({ isDeletingExecutiveSummary }) => isDeletingExecutiveSummary,
);

export const isEditExecutiveSummaryModalOpenSelector = createSelector(
  executiveSummarySelector,
  ({ isEditExecutiveSummaryModalOpen }) => isEditExecutiveSummaryModalOpen,
);
